import { render, staticRenderFns } from "./barcode.vue?vue&type=template&id=4dc77912&scoped=true"
import script from "./barcode.vue?vue&type=script&lang=js"
export * from "./barcode.vue?vue&type=script&lang=js"
import style0 from "./barcode.vue?vue&type=style&index=0&id=4dc77912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc77912",
  null
  
)

export default component.exports